export default {
  logo: {
    label: 'Logo',
    tooltip: 'Das gewählte Logo wird in der Kopfzeile eines jeden Reports angezeigt.',
  },
  errors: {
    unsupportedFileType: 'Das aktuelle Logo ist ein nicht unterstützes Dateiformat. Bitte lade ein neues Logo hoch.',
    logoLoadingFailure: 'Das aktuelle Logo konnte nicht geladen werden. Wir empfehlen ein neues Logo hochzuladen.',
  },
};
